<template>
  <div id="page">
    <div align="center" style="margin-top: 48px">
      <div>
        <img src="../../static/order_upload.png" width="96px" height="72px" />
      </div>
      <div style="margin-top: 8px">
        <label>上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
    </div>

    <div
      style="position: absolute; right: 24px; bottom: 24px"
      @click="toInvoice()"
    >
      <label>>>开具发票入口</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderResult",
  data() {
    return {
      orderNo: "",
    };
  },
  mounted: function () {
    this.orderNo = this.$route.params.orderNo;
    console.log("orderNo:" + this.orderNo);
  },
  methods: {
    toInvoice: function () {
      this.$router.replace({
        name: "Invoice",
        params: { orderNo: this.orderNo },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/OrderResult.vue